var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30.4711C16.56 30.4582 17.0973 30.2477 17.517 29.8768C17.9367 29.5059 18.2117 28.9986 18.2934 28.4445H13.6178C13.7018 29.0136 13.9896 29.5329 14.4278 29.9057C14.866 30.2785 15.4248 30.4794 16 30.4711Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 25.0044L28.8978 24.7378C28.0404 23.9738 27.2899 23.0978 26.6667 22.1333C25.986 20.8022 25.578 19.3486 25.4667 17.8578V13.4666C25.4631 12.9333 25.4155 12.4011 25.3245 11.8755C23.8188 11.5661 22.4663 10.7458 21.496 9.55356C20.5257 8.36135 19.9972 6.87046 20 5.33331V4.77331C19.0719 4.31659 18.0748 4.01626 17.0489 3.88443V2.76443C17.0489 2.4497 16.9239 2.14787 16.7013 1.92533C16.4788 1.70278 16.177 1.57776 15.8622 1.57776C15.5475 1.57776 15.2457 1.70278 15.0231 1.92533C14.8006 2.14787 14.6756 2.4497 14.6756 2.76443V3.92887C12.3784 4.25292 10.2761 5.39709 8.75665 7.15014C7.23723 8.9032 6.40332 11.1468 6.4089 13.4666V17.8578C6.29757 19.3486 5.88959 20.8022 5.2089 22.1333C4.59635 23.0954 3.85796 23.9713 3.01334 24.7378L2.71112 25.0044V27.5111H29.2V25.0044Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 9.7778C29.1213 9.7778 31.1111 7.78796 31.1111 5.33336C31.1111 2.87876 29.1213 0.888916 26.6667 0.888916C24.2121 0.888916 22.2222 2.87876 22.2222 5.33336C22.2222 7.78796 24.2121 9.7778 26.6667 9.7778Z",
    fill: "#C10606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d0781efab65d1f67b610aaff0f39363a.svg";
export { ForwardRef as ReactComponent };